import React from 'react';

export enum ATextInteractiveSize {
  XS = 'XS',
  S = 'S',
  M = 'M',
}

export interface ATextInteractiveProps extends React.HTMLAttributes<HTMLSpanElement | HTMLAnchorElement> {
  text: string;
  size?: ATextInteractiveSize;
  href?: string;
  // trackingProperties?: TrackingPropsInterface;
  trackingProperties?: Record<string, string | boolean>; // TODO: Remove this stub once we can import from mi-ui-library (DXP-30678)
  isExternal?: boolean;
  custom_click_track_value?: string;
  preTrackVal?: string;
}
